import type { PageData } from '@/types';
import * as ComponentData from './content.html';

const pageData: PageData = [
  {
    title: 'Initial Emissions Estimates',
    link: {
      anchor: 'initial-emissions-estimates',
      title: 'Initial Emissions Estimates',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C01,
          },
          {
            type: 'aside',
            content: ComponentData.C02,
          },
          {
            type: 'text',
            content: ComponentData.C03,
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C04,
          },
          {
            type: 'image',
            content: {
              url: '/img/m-fig-01.jpg',
              alt: 'NASA Nighttime Lights view of Australia',
              caption: `<strong>Figure 1.</strong> Satellite view of the nighttime lights in Australia, taken in June, 2023. <a href="https://worldview.earthdata.nasa.gov/" target="_blank">Nasa</a>`,
            },
          },
          {
            type: 'text',
            content: ComponentData.C05,
          },
          {
            type: 'aside',
            content: ComponentData.C06,
          },
        ],
      },
    ],
  },
  {
    title: 'Atmospheric Pollution Model',
    link: {
      anchor: 'atmospheric-pollution-model',
      title: 'Atmospheric Pollution Model',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C07,
          },
          {
            type: 'image',
            content: {
              url: '/img/m-fig-02.jpg',
              alt: 'A Map showing a large mesh, with a finer mesh inset',
              caption:
                '<strong>Figure 2.</strong> Integrating global and local forecasts and observations results in a more accurate model for atmospheric wind, temperature and pressure conditions.',
            },
          },
          {
            type: 'text',
            content: ComponentData.C08,
          },
        ],
      },
    ],
  },
  {
    title: 'Expected Atmospheric Concentrations',
    link: {
      anchor: 'expected-atmospheric-concentrations',
      title: 'Expected Atmospheric Concentrations',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C09,
          },
          {
            type: 'image',
            content: {
              url: '/img/m-fig-03.webp',
              alt: 'Combining the initial estimate with the atmospheric model creates a map of expected atmospheric concentrations.',
              caption:
                '<strong>Figure 3.</strong> Combining the initial estimate with the atmospheric model creates a map of expected atmospheric concentrations.',
            },
          },
          {
            type: 'text',
            content: ComponentData.C10,
          },
        ],
      },
    ],
  },
  {
    title: 'Satellite Observations',
    link: {
      anchor: 'satellite-observations',
      title: 'Satellite Observations',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C11Overview,
          },
          {
            type: 'image',
            content: {
              url: '/img/m-fig-04.png',
              alt: 'Cloud cover and dust in the atmosphere can complicate satellite measurements.',
              caption:
                '<strong>Figure 4.</strong> Cloud cover and dust in the atmosphere can complicate satellite measurements.',
            },
          },
          {
            type: 'text',
            content: ComponentData.C11,
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C12,
          },
          {
            type: 'image',
            content: {
              url: '/img/m-fig-05.jpg',
              alt: 'The Sentinel-5P satellite travels roughly North-South, while making across-track observations perpendicular to the direction of travel.',
              caption:
                '<strong>Figure 5.</strong> The Sentinel-5P satellite travels roughly North-South, while making across-track observations perpendicular to the direction of travel.',
            },
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C13,
          },
          {
            type: 'image',
            content: {
              url: '/img/m-fig-06.jpg',
              alt: 'TROPOMI cannot make methane measurements in cloudy locations.',
              caption:
                '<strong>Figure 6.</strong> TROPOMI cannot make methane measurements in cloudy locations.',
            },
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C14,
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C15Heading,
          },
          {
            type: 'image',
            content: {
              url: '/img/m-fig-07.png',
              alt: 'Satellites are effective at detecting plumes but also capture existing methane in the atmosphere, potentially obscuring the plume’s origin.',
              caption:
                '<strong>Figure 7.</strong> Satellites are effective at detecting plumes but also capture existing methane in the atmosphere, potentially obscuring the plume’s origin.',
            },
          },
          {
            type: 'text',
            content: ComponentData.C15,
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C16,
          },
        ],
      },
    ],
  },
  {
    title: 'Generating Alerts',
    link: {
      anchor: 'generating-alerts',
      title: 'Generating Alerts',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C17,
          },
          {
            type: 'aside',
            content: ComponentData.C18,
          },
          {
            type: 'text',
            content: ComponentData.C19,
          },
        ],
      },
    ],
  },
  {
    title: 'Emissions Corrections',
    link: {
      anchor: 'emissions-corrections',
      title: 'Emissions Corrections',
    },
    blocks: [
      {
        components: [
          {
            type: 'image',
            content: {
              url: '/img/m-fig-08.webp',
              alt: 'By running the atmospheric pollution model in reverse, we can correct for errors in our emissions inventory.',
              caption:
                '<strong>Figure 8.</strong> By running the atmospheric pollution model in reverse, we can correct for errors in our emissions inventory.',
            },
          },
          {
            type: 'text',
            content: ComponentData.C20,
          },
          {
            type: 'text',
            content: ComponentData.C21,
          },
          {
            type: 'text',
            content: ComponentData.C22,
          },
        ],
      },
    ],
  },
];

export default pageData;
